<template>
  <div>
    <div v-show="isTypeForm && researchInfo">
      <div id="_form" v-html="typeformHtml"></div>
    </div>
    <div class="wrapp">
      <div id="div-print">
        <!-- <button style="
      font-size: 2.3rem;
      color: #4ce595;
      margin-left: 5rem;
      margin-top: 2rem; border:none;" @click="exportPdfResearch()"><i class="fas fa-file-pdf"
      ></i>
    </button> -->
        <div v-if="loading" class="container">
          <div class="row">
            <div class="col-12 text-center mt-5">
              <b-spinner
                type="grow"
                style="color: #4ce595; width: 3rem; height: 3rem"
                label="Large Spinner"
              ></b-spinner>
            </div>
          </div>
        </div>
        <div v-else-if="displayClosingMessage" class="container header-safe-area">
          <div
            v-if="researchInfo.closingMessageEnabled && closingMessage.html"
            class="row"
          >
            <div class="col-12">
              <div v-if="closingMessage.useLogo" class="row">
                <div class="col-12 mt-3">
                  <div class="text-center">
                    <img :src="logo" style="height: 75px; max-width: 100%" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div
                  class="col-12 mb-4 mt-4 closing-message-area"
                  v-html="closingMessage.html"
                />
              </div>
            </div>
          </div>
          <div v-else class="row">
            <thankYouPage :lang="langView"/>
            <!-- <div class="col-12 text-center mt-4 closing-message-area">
              <span><i class="far fa-smile"></i></span>
              <h4 class="mt-4">
                {{ $t('researchPage.title') }}
              </h4>
              <span>
                {{ $t('researchPage.firstMsg') }}
              </span>
              <span>
                {{ $t('researchPage.secondMsg') }}
              </span>
            </div> -->
          </div>
        </div>
        <div v-else-if="error" class="container">
          <searchAnswered :lang="langView" :situationSearch="error === 'Essa pesquisa já foi expirada. Agradecemos sua participação.' ? 'searchExpired' : 'searchAnswered'"/>
          <!-- <div class="row">
            <div class="col-12 text-center mt-4 error-area">
              <span><i class="far fa-smile"></i></span>
              <h4 class="mt-4">
                {{ $t('researchPage.title') }}
              </h4>
              <span>{{ error }}</span>
            </div>
          </div> -->
        </div>
        <div v-else-if="researchInfo.action.paused" class="container">
          <Unavailable />
        </div>
        <div
          v-else
          class="container footer-safe-area"
          :style="{
            backgroundColor:
              researchInfo.action.email.template.scale !== 'colors'
                ? researchInfo.action.email.template.background
                : '#ffffff',
          }"
        >
          <div v-if="!isTypeForm">
            <div class="pt-2" v-if="researchInfo.enableTranslation">
              <b-button-group>
                <b-button
                  v-if="researchInfo.action.email.template.enableMyHTMLPt"
                  class="btn"
                  @click="setLangView('br')"
                  :variant="langView === 'br' ? 'primary' : ''"
                  ><country-flag country="br" size="normal"
                /></b-button>
                <b-button
                  v-if="researchInfo.action.email.template.enableMyHTMLEn"
                  class="btn"
                  @click="setLangView('us')"
                  :variant="langView === 'us' ? 'primary' : ''"
                  ><country-flag country="us" size="normal"
                /></b-button>
                <b-button
                  v-if="researchInfo.action.email.template.enableMyHTMLEs"
                  class="btn"
                  @click="setLangView('es')"
                  :variant="langView === 'es' ? 'primary' : ''"
                  ><country-flag country="es" size="normal"
                /></b-button>
              </b-button-group>
            </div>

            <div v-if="researchInfo.useLogo" class="row">
              <div class="col-12 mt-3">
                <div class="text-center">
                  <img :src="logo" style="height: 75px; max-width: 100%" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div id="body-email-modal" class="mt-3 mb-4" v-html="text" />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <template v-if="questionHTML">
                  <div class="text-center">
                    <div v-html="questionHTML"></div>
                  </div>
                </template>
                <template v-else>
                  <div class="text-center">
                    {{ question }}
                  </div>
                </template>
                <methodology
                  :lang="langView"
                  :surveySelectedColor="
                    researchInfo.action.email.template.templatebuttonselected
                  "
                  :actionMetric="researchInfo.metric"
                  :isLinkQrCode="false"
                  class="mt-4 mb-3"
                />
              </div>
            </div>

            <div v-if="researchInfo.commentPosition === 'up'" class="row mb-4">
              <div class="col-12">
                <div class="feedback-area mt-4" v-if="langView === 'br'">
                  <research-replys
                  v-if="!researchInfo.action.feedbackDisabled"
                    :style="{
                      color:
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000',
                    }"
                    :metric="researchInfo.metric"
                    :promotersReply="promotersQuestion"
                    :neutralReply="neutralQuestion"
                    :detractorsReply="detractorsQuestion"
                    :grade="testNpsReview"
                  />
                  <span v-if="displayRequiredFields" class="required mt-2">
                    *Obrigatório
                  </span>
                  <textarea
                  v-if="!researchInfo.action.feedbackDisabled"
                    v-model="feedback"
                    name=""
                    id="feedback"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
                <div class="feedback-area mt-4" v-if="langView === 'us'">
                  <research-replys
                  v-if="!researchInfo.action.feedbackDisabled"
                    :defaultFeedback="'What is the main reason for your grade?'"
                    :metric="researchInfo.metric"
                    :promotersReply="
                      researchInfo.action.reply.languageSupport.promotersEN
                    "
                    :neutralReply="
                      researchInfo.action.reply.languageSupport.neutralEN
                    "
                    :detractorsReply="
                      researchInfo.action.reply.languageSupport.detractorsEN
                    "
                    :grade="testNpsReview"
                  />
                  <span v-if="displayRequiredFields" class="required mt-2">
                    *Required
                  </span>
                  <textarea
                  v-if="!researchInfo.action.feedbackDisabled"
                    v-model="feedback"
                    name=""
                    id="feedback"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
                <div class="feedback-area mt-4" v-if="langView === 'es'">
                  <research-replys
                  v-if="!researchInfo.action.feedbackDisabled"
                    :defaultFeedback="'¿Cuál es la razón principal de tu calificación?'"
                    :metric="researchInfo.metric"
                    :promotersReply="
                      researchInfo.action.reply.languageSupport.promotersES
                    "
                    :neutralReply="
                      researchInfo.action.reply.languageSupport.neutralES
                    "
                    :detractorsReply="
                      researchInfo.action.reply.languageSupport.detractorsES
                    "
                    :grade="testNpsReview"
                  />
                  <span v-if="displayRequiredFields" class="required mt-2">
                    *Requerido
                  </span>
                  <textarea
                  v-if="!researchInfo.action.feedbackDisabled"
                    v-model="feedback"
                    name=""
                    id="feedback"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <hr v-if="researchInfo.additionalQuestions.length > 0" />
                <div
                  v-for="(item, i) in researchInfo.additionalQuestions"
                  :key="i"
                >
                  <div v-if="indicatorValuedQuestion(item)">
                    <template v-if="item.profileEnabled">
                      <template
                        v-if="
                          item.selectedProfile &&
                          item.selectedProfile.includes(conditionalQuestion())
                        "
                      >
                        <template
                          v-if="
                            promotersGrades.includes(testNpsReview) ||
                            detractorsGrades.includes(testNpsReview) ||
                            passivesGrades.includes(testNpsReview)
                          "
                        >
                          <!-- all mandatory questions -->
                          <span
                            v-if="
                              displayRequiredFields && item.type !== 'LABEL'
                            "
                            class="required"
                          >
                            *Obrigatório
                          </span>
                          <!-- -->

                          <!-- specific mandatory questions -->
                          <div
                            v-show="
                              verifyExistsDom(item.id) &&
                              showMessage &&
                              item.mandatory &&
                              item.type !== 'LABEL' &&
                              item.addQuestionAnswer &&
                              item.addQuestionAnswer.review === null
                            "
                          >
                            <span class="required"> *Obrigatório </span>
                          </div>

                          <div
                            v-show="
                              verifyExistsDom(item.id) &&
                              showMessage &&
                              item.mandatory &&
                              item.type === 'MULTIPLE' &&
                              item.addQuestionAnswerMultiple &&
                              item.addQuestionAnswerMultiple.multipleValues &&
                              item.addQuestionAnswerMultiple.multipleValues
                                .length === 0
                            "
                          >
                            <span class="required"> *Obrigatório </span>
                          </div>

                          <div
                            v-show="
                              (verifyExistsDom(item.id) &&
                                showMessage &&
                                item.mandatory &&
                                item.type === 'INPUT' &&
                                !item.answerText) ||
                              (item.answerText &&
                                item.answerText.review === null)
                            "
                          >
                            <span class="required"> *Obrigatório </span>
                          </div>
                          <!-- -->

                          <likert
                            :idQuestion="item.id"
                            v-if="item.type === 'LIKERT' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :lang="langView"
                            :text="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :item-id="i.toString()"
                            :index="i"
                            :colorTemplate="researchInfo.scale"
                            :commentEnabled="item.commentEnabled"
                            v-model="item.addQuestionAnswer"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :id="item.id"
                            :template="item.template"
                            @input="getReview"
                          />
                          <c-sat
                            :idQuestion="item.id"
                            v-if="item.type === 'CSAT' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :text="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :item-id="i.toString()"
                            :index="i"
                            :colorTemplate="researchInfo.scale"
                            v-model="item.addQuestionAnswer"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :id="item.id"
                            :template="item.template"
                            @input="getReview"
                            :lang="langView"
                          />
                          <star-rating
                            :idQuestion="item.id"
                            v-if="item.type === 'REVIEWS' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :text="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :item-id="i.toString()"
                            :index="i"
                            v-model="item.addQuestionAnswer"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :id="item.id"
                            @input="getReview"
                            :lang="langView"
                          />
                          <like-dislike
                            :idQuestion="item.id"
                            v-if="item.type === 'LIKE/DISLIKE' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :questionText="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :index="i"
                            v-model="item.addQuestionAnswer"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :id="item.id"
                            :item-id="i.toString()"
                            @input="getReview"
                            :lang="langView"
                          />
                          <emotion
                            :idQuestion="item.id"
                            :item-id="i.toString()"
                            v-if="item.type === 'EMOTION' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :questionText="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :index="i"
                            v-model="item.addQuestionAnswer"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :id="item.id"
                            @input="getReview"
                            :lang="langView"
                          />
                          <multiple-choices
                            :id="item.id"
                            :idQuestion="item.id"
                            :item-id="i.toString()"
                            v-if="
                              item.type === 'MULTIPLE' &&
                              item.template !== 'withSubOptions'
                              && !item.show && !item.display
                            "
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :type="item.multipleType"
                            :questionText="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :choices="item.choices"
                            :index="i"
                            v-model="item.addQuestionAnswerMultiple"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            @input="getReview"
                            :lang="langView"
                            :pageBackground="researchInfo.action.email.template.scale !== 'colors' ? researchInfo.action.email.template.background : ''"
                            :limitChoices="item.maximumAmountSelection"
                          />

                          <multiple-choices-custom
                            :id="item.id"
                            :idQuestion="item.id"
                            :item-id="i.toString()"
                            v-if="
                              item.type === 'MULTIPLE' &&
                              item.template === 'withSubOptions'
                              && !item.show && !item.display
                            "
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :type="item.multipleType"
                            :questionText="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :choices="item.choices"
                            :index="i"
                            v-model="item.addQuestionAnswerMultiple"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            @input="getReview"
                            :lang="langView"
                            :limitChoices="item.maximumAmountSelection"
                          />

                          <ces
                            :idQuestion="item.id"
                            v-if="item.type === 'CES' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :text="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :item-id="i.toString()"
                            :index="i"
                            :colorTemplate="researchInfo.scale"
                            v-model="item.addQuestionAnswer"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :id="item.id"
                            @input="getReview"
                            :lang="langView"
                          />

                          <likertEmotion
                            :idQuestion="item.id"
                            v-if="item.type === 'LIKERT/EMOTION' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :text="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :item-id="i.toString()"
                            :index="i"
                            :colorTemplate="researchInfo.scale"
                            v-model="item.addQuestionAnswer"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :id="item.id"
                            @input="getReview"
                            :lang="langView"
                          />

                          <label-question
                            v-if="item.type === 'LABEL' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :text="item.text"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :item-id="i.toString()"
                            :idQuestion="item.id"
                          />
                          <input-type
                            :id="item.id"
                            v-if="item.type === 'INPUT' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :text="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :index="i"
                            v-model="item.answerText"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :isMandatoryForQuestion="researchInfo.mandatory"
                            @input="getReview"
                            :placeholder="
                              langView === 'br'
                                ? 'Preencha aqui'
                                : langView === 'us'
                                ? 'Write here'
                                : 'Escribe aquí'
                            "
                            :item-id="i.toString()"
                            :idQuestion="item.id"
                          />

                          <input-type-cpf
                            :id="item.id"
                            v-if="item.type === 'INPUT-CPF' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :text="item.text"
                            :index="i"
                            v-model="item.answerText"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :isMandatoryForQuestion="researchInfo.mandatory"
                            @input="getReview"
                            :placeholder="
                              langView === 'br'
                                ? 'Preencha aqui'
                                : langView === 'us'
                                ? 'Write here'
                                : 'Escribe aquí'
                            "
                            :item-id="i.toString()"
                            :idQuestion="item.id"
                          />
                          <span
                            class="required"
                            v-if="
                              displayInvalidCpf && item.type === 'INPUT-CPF'
                              && !item.show && !item.display
                            "
                            >Não foi possível identificar, por favor, tente
                            novamente!</span
                          >
                          <nps
                            :idQuestion="item.id"
                            v-if="item.type === 'NPS' && !item.show && !item.display"
                            :textColor="
                              researchInfo.action.email.template.scale !==
                              'colors'
                                ? researchInfo.action.email.template
                                    .backgroundtext
                                : '#000000'
                            "
                            :text="
                              langView === 'br'
                                ? item.text
                                : langView === 'us'
                                ? item.textEN
                                : item.textES
                            "
                            :item-id="i.toString()"
                            :index="i"
                            :colorTemplate="researchInfo.scale"
                            v-model="item.addQuestionAnswer"
                            :commentEnabled="item.commentEnabled"
                            :applicableEnabled="item.applicableEnabled"
                            :addQuestionTemplate="
                              researchInfo.addQuestionTemplate
                            "
                            :id="item.id"
                            :template="item.template"
                            @input="getReview"
                            :lang="langView"
                          />
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <!-- all mandatory questions -->
                      <span
                        v-if="
                          verifyExistsDom(item.id) &&
                          displayRequiredFields &&
                          item.type !== 'LABEL'
                        "
                        class="required"
                      >
                        *Obrigatório
                      </span>
                      <!-- -->

                      <!-- specific mandatory questions -->
                      <div
                        v-show="
                          verifyExistsDom(item.id) &&
                          showMessage &&
                          item.mandatory &&
                          item.type !== 'LABEL' &&
                          item.addQuestionAnswer &&
                          item.addQuestionAnswer.review === null
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          verifyExistsDom(item.id) &&
                          showMessage &&
                          item.mandatory &&
                          item.type === 'MULTIPLE' &&
                          item.addQuestionAnswerMultiple &&
                          item.addQuestionAnswerMultiple.multipleValues &&
                          item.addQuestionAnswerMultiple.multipleValues
                            .length === 0
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          (verifyExistsDom(item.id) &&
                            showMessage &&
                            item.mandatory &&
                            item.type === 'INPUT' &&
                            !item.answerText) ||
                          (item.answerText && item.answerText.review === null)
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>
                      <!-- -->

                      <likert
                        v-if="item.type === 'LIKERT' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :lang="langView"
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :idQuestion="item.id"
                        @input="getReview"
                        :id="item.id"
                        :template="item.template"
                      />
                      <c-sat
                        v-if="item.type === 'CSAT' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :idQuestion="item.id"
                        @input="getReview"
                        :id="item.id"
                        :template="item.template"
                        :lang="langView"
                      />
                      <star-rating
                        v-if="item.type === 'REVIEWS' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :idQuestion="item.id"
                        @input="getReview"
                        :id="item.id"
                        :lang="langView"
                      />
                      <like-dislike
                        v-if="item.type === 'LIKE/DISLIKE' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        @input="getReview"
                        :id="item.id"
                        :lang="langView"
                      />
                      <emotion
                        v-if="item.type === 'EMOTION' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        @input="getReview"
                        :id="item.id"
                        :lang="langView"
                      />

                      <multiple-choices
                        :id="item.id"
                        v-if="
                          item.type === 'MULTIPLE' &&
                          item.template !== 'withSubOptions' &&
                          !item.show
                          && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :type="item.multipleType"
                        :questionText="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :choices="item.choices"
                        :index="i"
                        v-model="item.addQuestionAnswerMultiple"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        @input="getReview"
                        :lang="langView"
                        :pageBackground="researchInfo.action.email.template.scale !== 'colors' ? researchInfo.action.email.template.background : ''"
                        :limitChoices="item.maximumAmountSelection"
                      />

                      <multiple-choices-custom
                        :id="item.id"
                        v-if="
                          item.type === 'MULTIPLE' &&
                          item.template === 'withSubOptions' &&
                          !item.show
                          && !item.display
                        "
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :type="item.multipleType"
                        :questionText="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :choices="item.choices"
                        :index="i"
                        v-model="item.addQuestionAnswerMultiple"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        @input="getReview"
                        :lang="langView"
                        :limitChoices="item.maximumAmountSelection"
                      />

                      <ces
                        v-if="item.type === 'CES' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :idQuestion="item.id"
                        @input="getReview"
                        :id="item.id"
                        :lang="langView"
                      />

                      <likertEmotion
                        v-if="item.type === 'LIKERT/EMOTION' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :idQuestion="item.id"
                        @input="getReview"
                        :id="item.id"
                        :lang="langView"
                      />

                      <input-type
                        :id="item.id"
                        v-if="item.type === 'INPUT' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :index="i"
                        v-model="item.answerText"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        :isMandatoryForQuestion="researchInfo.mandatory"
                        @input="getReview"
                        :placeholder="
                          langView === 'br'
                            ? 'Preencha aqui'
                            : langView === 'us'
                            ? 'Write here'
                            : 'Escribe aquí'
                        "
                      />

                      <input-type-cpf
                        :id="item.id"
                        v-if="item.type === 'INPUT-CPF' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :index="i"
                        v-model="item.answerText"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        :isMandatoryForQuestion="researchInfo.mandatory"
                        @input="getReview"
                        :placeholder="
                          langView === 'br'
                            ? 'Preencha aqui'
                            : langView === 'us'
                            ? 'Write here'
                            : 'Escribe aquí'
                        "
                      />

                      <span
                        class="required"
                        v-if="displayInvalidCpf && item.type === 'INPUT-CPF'"
                        >Não foi possível identificar, por favor, tente
                        novamente!</span
                      >

                      <label-question
                        v-if="item.type === 'LABEL' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :item-id="i.toString()"
                        :idQuestion="item.id"
                        @input="getReview"
                      />
                      <nps
                        v-if="item.type === 'NPS' && !item.show && !item.display"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :idQuestion="item.id"
                        @input="getReview"
                        :template="item.template"
                        :lang="langView"
                      />
                      <template
                        v-if="item.displayType === 'formSearch' && !item.show && !item.display"
                      >
                        <contact
                          v-if="item.type === 'CONTACT'"
                          :textColor="
                            researchInfo.action.email.template.scale !==
                            'colors'
                              ? researchInfo.action.email.template
                                  .backgroundtext
                              : '#000000'
                          "
                          :type="item.displayType"
                          :questionText="
                            langView === 'br'
                              ? item.text
                              : langView === 'us'
                              ? item.textEN
                              : item.textES
                          "
                          :choices="item.choices"
                          :index="i"
                          v-model="dataContact"
                          :lang="langView"
                          :item-id="i.toString()"
                          :idQuestion="item.id"
                        />
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="researchInfo.commentPosition === 'down'" class="row">
              <div class="col-12">
                <div class="feedback-area mt-4" v-if="langView === 'br'">
                  <research-replys
                  v-if="!researchInfo.action.feedbackDisabled"
                    :style="{
                      color:
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000',
                    }"
                    :metric="researchInfo.metric"
                    :promotersReply="promotersQuestion"
                    :neutralReply="neutralQuestion"
                    :detractorsReply="detractorsQuestion"
                    :grade="testNpsReview"
                  />
                  <span v-if="displayRequiredFields" class="required mt-2">
                    *Obrigatório
                  </span>
                  <textarea
                  v-if="!researchInfo.action.feedbackDisabled"
                    v-model="feedback"
                    name=""
                    id="feedback"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
                <div class="feedback-area mt-4" v-if="langView === 'us'">
                  <research-replys
                  v-if="!researchInfo.action.feedbackDisabled"
                    :defaultFeedback="'What is the main reason for your grade?'"
                    :metric="researchInfo.metric"
                    :promotersReply="
                      researchInfo.action.reply.languageSupport.promotersEN
                    "
                    :neutralReply="
                      researchInfo.action.reply.languageSupport.neutralEN
                    "
                    :detractorsReply="
                      researchInfo.action.reply.languageSupport.detractorsEN
                    "
                    :grade="testNpsReview"
                  />
                  <span v-if="displayRequiredFields" class="required mt-2">
                    *Required
                  </span>
                  <textarea
                  v-if="!researchInfo.action.feedbackDisabled"
                    v-model="feedback"
                    name=""
                    id="feedback"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
                <div class="feedback-area mt-4" v-if="langView === 'es'">
                  <research-replys
                  v-if="!researchInfo.action.feedbackDisabled"
                    :defaultFeedback="'¿Cuál es la razón principal de tu calificación?'"
                    :metric="researchInfo.metric"
                    :promotersReply="
                      researchInfo.action.reply.languageSupport.promotersES
                    "
                    :neutralReply="
                      researchInfo.action.reply.languageSupport.neutralES
                    "
                    :detractorsReply="
                      researchInfo.action.reply.languageSupport.detractorsES
                    "
                    :grade="testNpsReview"
                  />
                  <span v-if="displayRequiredFields" class="required mt-2">
                    *Requerido
                  </span>
                  <textarea
                  v-if="!researchInfo.action.feedbackDisabled"
                    v-model="feedback"
                    name=""
                    id="feedback"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="row pt-2" v-if="researchInfo.enableAnonymous">
              <b-form-checkbox
                :disabled="researchInfo.action.allAnswersAnonymous"
                class="check-alert-modal ml-3"
                id="id-anonymous"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                v-model="anonymousResponse"
              >
              </b-form-checkbox>

              <label
                for="id-anonymous"
                style="margin-left: 15px"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                v-show="langView === 'br'"
              >
                {{ researchInfo.enableAnonymous }}
              </label>
              <label
                for="id-anonymous"
                style="margin-left: 15px"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                v-show="langView === 'us'"
              >
                {{ researchInfo.enableAnonymousEn }}
              </label>
              <label
                for="id-anonymous"
                style="margin-left: 15px"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                v-show="langView === 'es'"
              >
                {{ researchInfo.enableAnonymousEs }}
              </label>
            </div>
            <div v-if="enabledAudioResponse && !researchInfo.action.feedbackDisabled">
              <audio-recorder
                format="mp3"
                :bit-rate="128"
                upload-url="YOUR_API_URL"
                :attempts="1"
                :time="1"
                :headers="headers"
                :before-recording="callback"
                :pause-recording="callback"
                :after-recording="callback"
                :select-record="callback"
                :before-upload="callback"
                :successful-upload="callback"
                :failed-upload="callback"
              />
            </div>
            <div class="row mt-5">
              <div class="col-12 text-center mt-2 mb-3 btn-send">
                <template v-if="typeModalContact">
                  <b-button
                    v-b-modal.modal-send
                    @click="submit"
                    variant="btn btn-primary"
                    >Enviar!</b-button
                  >
                  <template v-if="validateFields">
                    <b-modal
                      id="modal-send"
                      hide-footer
                      hide-header
                      :no-close-on-backdrop="true"
                      hide-header-close
                    >
                      <div class="row mt-2">
                        <div class="col-12">
                          <div
                            v-for="(
                              item, i
                            ) in researchInfo.additionalQuestions"
                            :key="i"
                          >
                            <contact
                              v-if="item.type === 'CONTACT'"
                              :type="item.displayType"
                              :questionText="
                                langView === 'br'
                                  ? item.text
                                  : langView === 'us'
                                  ? item.textEN
                                  : item.textES
                              "
                              :choices="item.choices"
                              :index="i"
                              v-model="dataContact"
                              :lang="langView"
                            />
                          </div>
                        </div>
                      </div>
                      <b-button
                        class="mt-3"
                        block
                        variant="btn btn-primary"
                        @click="updateContactInfo"
                        >Enviar</b-button
                      >
                    </b-modal>
                  </template>
                </template>
                <template v-else>
                  <div v-if="researchInfo.submitButtonEnabled">
                    <button
                      :disabled="loadingSubmit"
                      :style="{
                        boxShadow: `0px 10px 30px -7px ${
                          researchInfo.action.email.template.buttonColor ||
                          '#cccccc'
                        }`,
                        backgroundColor: researchInfo.action.email.template
                          .buttonColor
                          ? researchInfo.action.email.template.buttonColor
                          : '',
                        borderColor: researchInfo.action.email.template
                          .buttonBorderColor
                          ? researchInfo.action.email.template.buttonBorderColor
                          : '',
                        color: researchInfo.action.email.template
                          .buttonTextColor
                          ? researchInfo.action.email.template.buttonTextColor
                          : '',
                      }"
                      class="btn btn-primary px-5 py-2"
                      @click="submit"
                    >
                      <span v-show="langView === 'br'">
                        {{
                          researchInfo.action.email.template
                            .submitButtonValue || $t('researchPage.send')
                        }}
                      </span>
                      <span v-show="langView === 'us'">
                        {{
                          researchInfo.action.email.template
                            .submitButtonValueEn || $t('researchPage.send')
                        }}
                      </span>
                      <span v-show="langView === 'es'">
                        {{
                          researchInfo.action.email.template
                            .submitButtonValueEs || $t('researchPage.send')
                        }}
                      </span>
                    </button>
                  </div>
                  <div v-else>
                    <button
                      :disabled="loadingSubmit"
                      class="btn btn-primary px-5 py-2 btn-shadow"
                      @click="submit"
                    >
                      {{ $t('researchPage.send') }}
                    </button>
                  </div>
                </template>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center mt-5">
                <hr />
                <div
                  class="template-footer-modal mt-4 mb-4"
                  v-if="researchInfo.footer"
                >
                  <a href="https://www.indecx.com.br/">
                    <img
                      src="../../../assets/logo-indecx.png"
                      style="width: 80px"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div v-if="researchInfo.textprivacyPolicy" class="row">
              <div class="col-12 text-center mb-4">
                <span style="font-size: 0.9em" v-show="langView === 'br'"
                  ><a
                    :href="researchInfo.linkprivacyPolicy"
                    style="color: #212529"
                    target="_blank"
                    :style="{
                      color:
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000',
                    }"
                    >{{ researchInfo.textprivacyPolicy }}</a
                  ></span
                >
                <span style="font-size: 0.9em" v-show="langView === 'us'"
                  ><a
                    :href="researchInfo.linkprivacyPolicy"
                    :style="{
                      color:
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000',
                    }"
                    target="_blank"
                    >{{ researchInfo.textprivacyPolicyEn }}</a
                  ></span
                >
                <span style="font-size: 0.9em" v-show="langView === 'es'"
                  ><a
                    :href="researchInfo.linkprivacyPolicy"
                    :style="{
                      color:
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000',
                    }"
                    target="_blank"
                    >{{ researchInfo.textprivacyPolicyEs }}</a
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="loadingSubmit" v-if="sendLoading">
      <Spinner name="wave" color="#86f470" />
      <span style="color: #fff; font-size: 20px; margin-left: -18px;"
        >Enviando...</span
      >
    </div> -->
    </div>
  </div>
</template>

<script>
import JsPdf from 'jspdf';
import Html2canvas from 'html2canvas';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import CountryFlag from 'vue-country-flag';
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import Spinner from 'vue-spinkit';
import swal from 'sweetalert';
import bowser from 'bowser';
import cSat from '@/components/molecules/metrics/csat';
import nps from '@/components/molecules/metrics/nps';
import ces from '@/components/molecules/metrics/ces';
import likert from '@/components/molecules/metrics/likert';
import starRating from '@/components/molecules/metrics/reviews';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import multipleChoicesCustom from '@/components/molecules/metrics/multiple-choices-custom';
import inputType from '@/components/molecules/metrics/input-type';
import inputTypeCpf from '@/components/molecules/metrics/input-type-cpf';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import contact from '@/components/molecules/metrics/contact';
import labelQuestion from '@/components/molecules/metrics/label-question';
import methodology from '@/components/molecules/action-templates/methodology';
import researchReplys from '@/components/atoms/research-replys';
import Unavailable from '@/components/pages/unavailable';
import validator from 'validator';
import api from '../../../services/api';
import thankYouPage from '../../pages/final-pages/thank-you-page';
import searchAnswered from '../../pages/final-pages/search-already-answered';
import EventBus from '../../../eventBus';

export default {
  components: {
    methodology,
    cSat,
    nps,
    likert,
    starRating,
    likeDislike,
    emotion,
    multipleChoices,
    multipleChoicesCustom,
    inputType,
    inputTypeCpf,
    contact,
    researchReplys,
    labelQuestion,
    Spinner,
    ces,
    CountryFlag,
    likertEmotion,
    Unavailable,
    thankYouPage,
    searchAnswered
  },
  data: () => ({
    typeformHtml: '',
    isTypeForm: false,
    apiCallsCount: 0,
    displayInvalidCpf: false,
    indicators: null,
    audio: null,
    enabledAudioResponse: false,
    headers: {
      'X-Custom-Header': 'somedata',
    },
    anonymousResponse: false,
    researchInfo: {
      reply: {},
      additionalQuestions: [],
    },
    dataContact: {
      name: null,
      email: null,
      phone: null,
    },
    logo: null,
    error: false,
    loading: true,
    answer: {},
    feedback: '',
    apiRoot: null,
    apiServerless: null,
    loadingSubmit: false,
    errorMsg: null,
    displayRequiredFields: false,
    typeModalContact: false,
    answerId: null,
    validateFields: true,
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
    closingMessage: {
      useLogo: false,
      html: null,
    },
    displayClosingMessage: false,
    promotersQuestion: null,
    neutralQuestion: null,
    detractorsQuestion: null,
    company: null,
    afterAnswer: false,
    text: null,
    question: null,
    questionHTML: null,
    myHTML: null,
    langView: null,
    showMessage: false,
    visitorId: null,
  }),
  methods: {
    ...mapActions('research', ['getInfo', 'setAnswer']),
    ...mapActions('actions', ['setTestNpsReview']),

    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    verifyExistsDom(id) {
      return document.getElementById(id);
    },

    exportPdfResearch() {
      // const text = 'download de ação da indecx';

      setTimeout(() => {
        const myDiv = document.getElementById('div-print');

        Html2canvas(myDiv, {
          allowTaint: false,
          scale: 2,
          useCORS: true,
          // foreignObjectRendering: true
        }).then((canvas) => {
          if (canvas.height < 1730) {
            const imgWidth = 500;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const imageData = canvas.toDataURL('image/png');
            const pdf = new JsPdf('l', 'mm', 'a4', true);
            const x = 5;
            const y = 8;

            pdf.addImage(
              imageData,
              'PNG',
              x,
              y,
              imgWidth,
              imgHeight,
              '',
              'FAST',
            );
            pdf.setFontSize(10.0);
            pdf.setTextColor(115, 115, 115);
            pdf.setFontType('bold');
            // pdf.text(text, 2, 5);
            pdf.save('indecx.pdf');
          } else {
            const contentWidth = canvas.width;
            const contentHeight = canvas.height;
            const pageData = canvas.toDataURL('image/jpeg', 1.0);
            const pdfX = ((contentWidth + 5) / 2) * 0.75;
            const pdfY = (contentHeight + 500) * 0.75;
            const imgX = pdfX - 35;
            const imgY = (contentHeight / 2) * 0.75;
            const pdf = new JsPdf('', 'pt', [pdfX, pdfY], true);

            pdf.addImage(pageData, 'JPEG', 20, 30, imgX, imgY, '', 'FAST');
            pdf.setFontSize(10.0);
            pdf.setTextColor(115, 115, 115);
            pdf.setFontType('bold');
            // pdf.text(text, 15, 20);
            pdf.save('indecx.pdf');
          }
        });
      }, 200);
    },

    setLangView(locale) {
      this.langView = locale;

      if (this.langView === 'br') {
        this.text = this.researchInfo.text;
        this.question = this.researchInfo.action.question;
        this.questionHTML = this.researchInfo.action.questionHTML;
        this.myHTML = this.researchInfo.action.email.template.myHTML;
      }
      if (this.langView === 'us') {
        this.text = this.researchInfo.textEn;
        this.question = this.researchInfo.action.questionEn;
        this.questionHTML = this.researchInfo.action.questionHTMLEn;
        this.myHTML = this.researchInfo.action.email.template.myHTMLEn;
      }
      if (this.langView === 'es') {
        this.text = this.researchInfo.textEs;
        this.question = this.researchInfo.action.questionEs;
        this.questionHTML = this.researchInfo.action.questionHTMLEs;
        this.myHTML = this.researchInfo.action.email.template.myHTMLEs;
      }
    },
    isVisible(item, value) {
      if (item.logicalRuleEnabled && item.conditionalRule) {
        let res = false;
        switch (item.conditionalRule) {
          case 'equal': // igual
            if (item.type === 'MULTIPLE') {
              if (!value.isMultipleChoiceCustom) {
                if (item.multipleType === 'radio') {
                  value.multipleValues = this.returnTextInBr(item.choices, value.multipleValues);

                  res =
                    value.multipleValues === item.conditionalValue
                      ? true
                      : false;
                } else {
                  res = value.multipleValues.includes(item.conditionalValue);
                }
              }

              if (value.isMultipleChoiceCustom) {
                if (value.options && value.options.length > 0) {
                  for (let i = 0; i < value.options.length; i += 1) {
                    if (value.options[i].text === item.conditionalValue) {
                      res = true;
                      break;
                    }
                  }
                }
              }
            } else {
              res =
                Number(value.review) === item.conditionalValue ? true : false;
            }
            break;

          case 'differentThan': // diferente
            if (item.type === 'MULTIPLE') {
              if (!value.isMultipleChoiceCustom) {
                if (item.multipleType === 'radio') {
                  value.multipleValues = this.returnTextInBr(item.choices, value.multipleValues);

                  res =
                    value.multipleValues !== item.conditionalValue
                      ? true
                      : false;
                } else {
                  res = value.multipleValues.includes(item.conditionalValue);
                }
              }

              if (value.isMultipleChoiceCustom) {
                if (value.options && value.options.length > 0) {
                  for (let i = 0; i < value.options.length; i += 1) {
                    if (value.options[i].text !== item.conditionalValue) {
                      res = true;
                      break;
                    }
                  }
                }
              }
            } else {
              res =
                Number(value.review) !== item.conditionalValue ? true : false;
            }
            break;

          case 'biggerThen': // maior que
            res = value.review > item.conditionalValue ? true : false;
            break;

          case 'greaterOrEqualTo': // maior ou igual
            res = value.review >= item.conditionalValue ? true : false;
            break;

          case 'lessThan': // menor que
            res = value.review < item.conditionalValue ? true : false;
            break;

          case 'lessThanOrEqualTo': // menor ou igual
            res = value.review <= item.conditionalValue ? true : false;
            break;

          default:
            break;
        }
        return res;
      }
      return false;
    },

    returnTextInBr(array, itemSelected) {
      let text;
      for (let index = 0; index < array.length; index+=1) {
        if (array[index].text === itemSelected || array[index].textEN === itemSelected || array[index].textES === itemSelected) {
           text = array[index].text;
        }
      }
      return text;
    },

    // eslint-disable-next-line
    getReview(value, indexPosition) {
      // const index = Number(value.position || indexPosition);
      const index = Number(value.position);
      const item = this.researchInfo.additionalQuestions[index];

      let gradeQuestion = null;

      if (
        this.researchInfo.additionalQuestions[index] &&
        this.researchInfo.additionalQuestions[index].answerText
      ) {
        this.researchInfo.additionalQuestions[index].answerText = value.review;
      }

      // force dom update
      if (item && item.type && item.type !== 'MULTIPLE' && item.type !== 'INPUT') {
        gradeQuestion = value.review;
      } else if (item && item.type && item.type === 'INPUT') {
        gradeQuestion = value.review ? value.review : value;
        this.researchInfo.additionalQuestions[index].answerText = value.review
          ? value.review
          : value;
      } else {
        gradeQuestion = value.multipleValues;
      }

      // eslint-disable-next-line
      if (
        item && item.type === 'INPUT-CPF' &&
        value.review.length === 14 &&
        this.researchInfo.enableApiCpf
      ) {
        this.processCpfApi(value.review, index);
      }

      this.$set(
        this.researchInfo.additionalQuestions[index],
        'gradeAddQuestion',
        gradeQuestion,
      );

      if (item && item.idsDisabled && item.idsDisabled.length > 0) {
        item.idsDisabled.forEach((el) => {
          for (
            let i = 0;
            i < this.researchInfo.additionalQuestions.length;
            i += 1
          ) {
            if (this.researchInfo.additionalQuestions[i].id === el && value.review !== -1) {
              this.researchInfo.additionalQuestions[i].show = this.isVisible(
                item,
                value,
              );

              if (
                !this.researchInfo.additionalQuestions[i].show
              ) {
                this.researchInfo.additionalQuestions[i].display = false;
              } else {
                this.researchInfo.additionalQuestions[i].display = true;
              }
            } else {
              // this.researchInfo.additionalQuestions[i].display = false;
            }
          }
        });

        const arr = this.researchInfo.additionalQuestions;
        this.researchInfo.additionalQuestions = [];
        this.researchInfo.additionalQuestions = arr;
      }
    },

    async processCpfApi(cpf, index) {
      this.displayInvalidCpf = false;
      // eslint-disable-next-line
      this.apiCallsCount++;

      let response = null;

      try {
        response = await api.post('/gndi-cpf-api', {
          cpf: `${cpf}`,
        });

        if (response.data) {
          this.indicators = [];

          const obj = response.data;

          Object.keys(obj).forEach((key) => {
            const indicatorIndex = this.indicators.findIndex(
              (item) => item.column.toLowerCase() === key.toLowerCase(),
            );
            if (indicatorIndex >= 0) {
              this.indicators[indicatorIndex] = {
                column: key,
                value: obj[key],
              };
            } else {
              this.indicators.push({ column: key, value: obj[key] });
            }
          });
        } else if (this.apiCallsCount <= 3 && response.data.status === 0) {
          this.displayInvalidCpf = true;
        }
      } catch (error) {
        if (this.apiCallsCount <= 3) {
          const element = document.getElementById(`input-type-cpf-${index}`);
          element.value = '';
        } else if (this.apiCallsCount <= 3 && response.data.status === 0) {
          this.displayInvalidCpf = true;
        }
      }
    },

    callback(ev) {
      if (ev.blob) {
        this.audio = ev.blob;
      }
    },
    async blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    conditionalQuestion() {
      if (this.promotersGrades.includes(this.testNpsReview)) {
        return 'promotor';
      } else if (this.detractorsGrades.includes(this.testNpsReview)) {
        return 'detrator';
      }

      return 'neutro';
    },

    async submit() {
      this.loadingSubmit = true;

      if (this.enabledAudioResponse) {
        this.enabledAudioResponse = false;
        setTimeout(() => {
          this.enabledAudioResponse = true;
        });

        if (!this.audio) {
          await new Promise((resolve) => setTimeout(resolve, 800));
        }
      }

      const validate = this.verifyFields();

      let verifyCpf = true;

      if (this.researchInfo.enableApiCpf && this.displayInvalidCpf) {
        verifyCpf = false;
        this.errorMsg = 'Por favor, verifique o campo CPF!';
      }

      if (validate && verifyCpf) {
        let channel;
        switch (this.researchInfo.channel) {
          case 'E': {
            channel = 'email';
            break;
          }
          case 'S': {
            channel = 'sms';
            break;
          }
          case 'L': {
            channel = 'link';
            break;
          }
          case 'W': {
            channel = 'whatsapp';
            break;
          }
          default: {
            channel = 'email';
            break;
          }
        }

        if (this.$route.query && this.$route.query.c === 'M') {
          channel ='manual';

          const hasUserlogged = localStorage.getItem('_indecx');
          if(hasUserlogged){
            const userData = JSON.parse(hasUserlogged);
            if(userData._id){
              this.answer.answeredByUser = userData._id;
              this.answer.loggedUser = userData.name;
            }
          }
        }

        this.answer.companyId = this.researchInfo.action.companyId;
        this.answer.name = this.dataContact.name;
        this.answer.email = this.dataContact.email;
        this.answer.phone = this.dataContact.phone;
        this.answer.review = this.testNpsReview;
        this.answer.feedback = this.feedback;
        this.answer.additionalQuestions = this.researchInfo.additionalQuestions;
        this.answer.channel = channel;
        this.answer.token = this.$route.params.token;
        this.answer.lang = this.langView;
        this.answer.anonymousResponse = !this.researchInfo.enableAnonymous
          ? this.researchInfo.enableAnonymous
          : this.anonymousResponse;

        this.answer.deviceInfo = this.getDeviceInfo();
        this.answer.deviceInfo.visitorId = this.visitorId;
        this.answer.enableServerless = this.company.enableServerless;

        if (
          this.researchInfo.enableApiCpf &&
          this.indicators &&
          this.indicators.length
        ) {
          this.answer.indicators = this.indicators;
        }

        this.answer.additionalQuestions.forEach((el, index) => {
          if (this.langView === 'br') {
            el.text = el.text;
          } else if (this.langView === 'us') {
            el.text = el.textEN;
          } else if (this.langView === 'es') {
            el.text = el.textES;
          }
          if (el.addQuestionAnswer) {
            el.review = el.addQuestionAnswer.review;
            el.comment = el.addQuestionAnswer.comment || undefined;
            el.conditionalQuestion = this.getConditionalQuestion(el);
          }

          el.conditionalQuestion = this.getConditionalQuestion(el);

          delete this.answer.additionalQuestions[index].addQuestionAnswer;

          if (el.addQuestionAnswerMultiple) {
            if (el.template !== 'withSubOptions') {
              el.multipleValues =
                el.addQuestionAnswerMultiple.multipleValues || [];
            } else if (el.template === 'withSubOptions') {
              el.options = el.addQuestionAnswerMultiple.options || [];
            }

            if (!el.template || el.template !== 'withSubOptions') {
              // limpa os campos selecionados se nao mostrou mais essa pergunta para o usuario - regra condicional
              if (el.show) {
                el.multipleValues = [];
              }
            }

            el.comment = el.addQuestionAnswerMultiple.comment || undefined;
            el.conditionalQuestion = this.getConditionalQuestion(el);
            el.isAnswered = this.getIsAnswered(el);
          }

          if (el.show) {
            // se a pergunta nao aparece na tela, limpa as notas atribuidas a ela
            el.review = null;
            el.answerText = null;
          }

          delete this.answer.additionalQuestions[index]
            .addQuestionAnswerMultiple;

            if(el.profileEnabled){
              if(el.selectedProfile === 'detrator' && !this.detractorsGrades.includes(this.answer.review)){
                this.researchInfo.additionalQuestions[index].options = []
              } else if(el.selectedProfile === 'neutro' && !this.passivesGrades.includes(this.answer.review)){
                this.researchInfo.additionalQuestions[index].options = []
              } else if(el.selectedProfile === 'promotor' && !this.promotersGrades.includes(this.answer.review)){
                this.researchInfo.additionalQuestions[index].options = []
              }
            }
        });

        try {
          if (this.audio) {
            this.answer.audioBase64 = await this.blobToBase64(this.audio);
          } else {
            this.answer.audioBase64 = null;
          }

          const response = await this.setAnswer(this.answer);
          this.answerId = response._id;
          if (!this.typeModalContact) {
            this.displayClosingMessage = true;
          }
          this.handleClosingMessage();
        } catch (error) {
          window.console.log(error);
          swal(
            this.$t('researchPage.errorMsg.title'),
            this.$t('researchPage.errorMsg.description'),
            'error',
          );
        }
      } else {
        swal('Oops...', this.errorMsg, 'warning');
      }
      this.loadingSubmit = false;
    },

    async updateContactInfo() {
      if (
        this.dataContact.email &&
        !validator.isEmail(this.dataContact.email)
      ) {
        swal(
          this.$t('researchPage.errorMsg.title'),
          'Insira um e-mail válido',
          'warning',
        );
      } else {
        // serverless test
        if (this.company.enableServerless && this.apiServerless) {
          await axios.put(
            `${this.apiServerless}/answer/data-contact/${this.answerId}`,
            {
              name: this.dataContact.name,
              email: this.dataContact.email,
              phone: this.dataContact.phone,
            },
          );
        } else {
          await api.put(`/answer/data-contact/${this.answerId}`, {
            name: this.dataContact.name,
            email: this.dataContact.email,
            phone: this.dataContact.phone,
          });
        }

        this.displayClosingMessage = true;
      }
    },

    fillArray() {
      const arr = [];

      this.researchInfo.additionalQuestions.forEach((el) => {
        if (el.selectedProfile) {
          if (
            this.promotersGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('promotor')
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
              indicatorCriterion: el.indicatorCriterion,
              mandatorySubOption: el.mandatorySubOption
            });
          } else if (
            this.passivesGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('neutro')
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
              indicatorCriterion: el.indicatorCriterion,
              mandatorySubOption: el.mandatorySubOption
            });
          } else if (
            this.detractorsGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('detrator')
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
              indicatorCriterion: el.indicatorCriterion,
              mandatorySubOption: el.mandatorySubOption
            });
          }
        } else if (
          el.selectedProfile === null ||
          el.selectedProfile === undefined
        ) {
          arr.push({
            answerText: el.answerText,
            applicableEnabled: el.applicableEnabled,
            commentEnabled: el.commentEnabled,
            profileEnabled: el.profileEnabled,
            review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
            selectedProfile: el.selectedProfile,
            text: el.text,
            type: el.type,
            addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
            choices: el.choices,
            indicatorValue: el.indicatorValue,
            indicatorValueEnabled: el.indicatorValueEnabled,
            selectedIndicator: el.selectedIndicator,
            feedback: el.feedback,
            mandatory: el.mandatory,
            id: el.id,
            indicatorCriterion: el.indicatorCriterion,
            mandatorySubOption: el.mandatorySubOption
          });
        }
      });

      return arr;
    },

    verifyFields() {
      this.errorMsg = null;

      if (this.researchInfo.allAnswersRequired) {
        let isValid = true;
        const arr = this.fillArray();

        for (let i = 0; i < arr.length; i += 1) {
          const question = arr[i];

          const showQuestion = this.indicatorValuedQuestion(question);
          if (showQuestion) {
            const existOnDom = document.getElementById(question.id);
            if (
              existOnDom &&
              !question.review &&
              question.review !== 0 &&
              question.type !== 'MULTIPLE' &&
              question.type !== 'LABEL' &&
              question.type !== 'INPUT' &&
              question.type !== 'CONTACT'
            ) {
              isValid = false;
              break;
            }
            if (question.type !== 'LABEL') {
              if (question.type === 'MULTIPLE') {
                if (
                  existOnDom &&
                  question.addQuestionAnswerMultiple.multipleValues &&
                  question.addQuestionAnswerMultiple.multipleValues.length <= 0
                ) {
                  isValid = false;
                  this.validateFields = false;
                  break;
                }

                if (question.mandatorySubOption && question.mandatorySubOption !== undefined) {
                  if (question.addQuestionAnswerMultiple.options && question.addQuestionAnswerMultiple.options.length === 0) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }

                  if (question.addQuestionAnswerMultiple.options && question.addQuestionAnswerMultiple.options.length > 0) {
                    const listSubOptionsIsEmpty = question.addQuestionAnswerMultiple.options.some((item) => item.subOptions.length === 0);
                    if (listSubOptionsIsEmpty){
                      isValid = false;
                      this.validateFields = false;
                      break;
                    }
                  }
                }
              } else if (question.type === 'INPUT') {
                if (existOnDom && !question.answerText) {
                  isValid = false;
                  this.validateFields = false;
                  break;
                }
              } else if (question.type === 'CONTACT') {
                const contactTypes = question.choices || [];
                const hasName = contactTypes.indexOf('name');
                const hasEmail = contactTypes.indexOf('email');
                const hasPhone = contactTypes.indexOf('phone');
                if (question.displayType === 'formSearch') {
                  if (hasName >= 0 && !this.dataContact.name) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }
                  if (hasEmail >= 0 && !this.dataContact.email) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }
                  if (hasPhone >= 0 && !this.dataContact.phone) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }
                }
              } else if (
                this.testNpsReview === null ||
                this.testNpsReview === undefined
              ) {
                isValid = false;
                this.validateFields = false;
                break;
              }
            }
          }
        }

        if (!this.researchInfo.action.feedbackDisabled && !this.feedback) {
          isValid = false;
          this.validateFields = false;
        }

        if (!isValid) {
          this.errorMsg = 'Por favor, preencha todos os campos obrigatórios.';
          this.displayRequiredFields = true;
        }
      }

      if (this.researchInfo.customMandatoryQuestion) {
        let isValid = true;

        let arr = [];

        arr = this.fillArray();

        let fields = [];

        arr.forEach((element) => {
          if (element.type !== 'REVIEWS') {
            fields = arr.filter(
              (item) => item.mandatory && item.review === null,
            );
          }
        });

        if (fields.length) {
          this.showMessage = true;
        } else {
          this.showMessage = false;
        }

        for (let i = 0; i < arr.length; i += 1) {
          const question = arr[i];

          const showQuestion = this.indicatorValuedQuestion(question);

          if (showQuestion) {
            const existOnDom = document.getElementById(question.id);
            if (
              existOnDom &&
              !question.review &&
              question.review !== 0 &&
              question.type !== 'MULTIPLE' &&
              question.type !== 'LABEL' &&
              question.type !== 'INPUT' &&
              question.type !== 'CONTACT' &&
              question.mandatory
            ) {
              this.validateFields = false;
              isValid = false;
              break;
            }
            if (question.type !== 'LABEL') {
              if (question.type === 'MULTIPLE') {
                if (
                  existOnDom &&
                  question.addQuestionAnswerMultiple.multipleValues &&
                  question.addQuestionAnswerMultiple.multipleValues.length <=
                    0 &&
                  question.mandatory
                ) {
                  this.validateFields = false;
                  isValid = false;
                  break;
                }

                if (question.mandatorySubOption && question.mandatorySubOption !== undefined) {
                  if (question.addQuestionAnswerMultiple.options && question.addQuestionAnswerMultiple.options.length === 0) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }

                  if (question.addQuestionAnswerMultiple.options && question.addQuestionAnswerMultiple.options.length > 0) {
                    const listSubOptionsIsEmpty = question.addQuestionAnswerMultiple.options.some((item) => item.subOptions.length === 0);
                    if (listSubOptionsIsEmpty){
                      isValid = false;
                      this.validateFields = false;
                      break;
                    }
                  }
                }
              } else if (
                existOnDom &&
                question.mandatory &&
                question.type === 'INPUT'
              ) {
                if (!question.answerText) {
                  this.validateFields = false;
                  isValid = false;
                  break;
                }
              } else if (question.type === 'CONTACT' && question.mandatory) {
                const contactTypes = question.choices || [];
                const hasName = contactTypes.indexOf('name');
                const hasEmail = contactTypes.indexOf('email');
                const hasPhone = contactTypes.indexOf('phone');

                if (question.displayType === 'formSearch') {
                  if (hasName >= 0 && !this.dataContact.name) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }

                  if (hasEmail >= 0 && !this.dataContact.email) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }

                  if (hasPhone >= 0 && !this.dataContact.phone) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }
                }
              } else if (
                this.testNpsReview === null ||
                this.testNpsReview === undefined
              ) {
                this.validateFields = false;
                isValid = false;
                break;
              }
            }
          }
        }

        // if (!this.feedback) {
        //   isValid = false;
        //   this.validateFields = false;
        // }

        if (!isValid) {
          this.errorMsg = 'Por favor, preencha todos os campos obrigatórios.';
        }
      }

      if (!Number.isInteger(this.testNpsReview)) {
        if (this.langView === 'br') {
          this.errorMsg = 'Por favor, responda nossa pergunta principal para enviar a resposta.';
        } else if (this.langView === 'us') {
          this.errorMsg = 'Please answer our main question to submit the answer.'
        } else {
          this.errorMsg = 'Responda nuestra pregunta principal para enviar la respuesta.'
        }
      }
      if (
        this.researchInfo.metric === 'nps-0-10' &&
        this.testNpsReview < 0 &&
        this.testNpsReview > 10
      ) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }
      if (
        this.researchInfo.metric === 'nps-1-5' &&
        this.testNpsReview < 1 &&
        this.testNpsReview > 5
      ) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }
      if (this.errorMsg) {
        this.validateFields = false;
        return false;
      }
      this.validateFields = true;
      return true;
    },

    handleClosingMessage() {
      if (
        this.researchInfo.closingMessageEnabled &&
        this.researchInfo.closingMessage
      ) {
        if (this.researchInfo.closingMessage.dynamic) {
          if (
            this.researchInfo.closingMessage.promoters &&
            this.promotersGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.researchInfo.closingMessage.promoters.useLogo;
            this.closingMessage.html =
              this.researchInfo.closingMessage.promoters.html;
          } else if (
            this.researchInfo.closingMessage.passives &&
            this.passivesGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.researchInfo.closingMessage.passives.useLogo;
            this.closingMessage.html =
              this.researchInfo.closingMessage.passives.html;
          } else if (
            this.researchInfo.closingMessage.detractors &&
            this.detractorsGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo =
              this.researchInfo.closingMessage.detractors.useLogo;
            this.closingMessage.html =
              this.researchInfo.closingMessage.detractors.html;
          }
        } else if (this.researchInfo.closingMessage.default) {
          this.closingMessage.useLogo =
            this.researchInfo.closingMessage.default.useLogo;
          this.closingMessage.html =
            this.researchInfo.closingMessage.default.html;

          if (this.langView === 'us') {
            this.closingMessage.html =
              this.researchInfo.closingMessage.closingMessageEn;
          } else if (this.langView === 'es') {
            this.closingMessage.html =
              this.researchInfo.closingMessage.closingMessageEs;
          }
        }

        if (this.closingMessage.html) {
          this.closingMessage.html = this.closingMessage.html.replace(
            /<img src/gi,
            '<img style="max-width: 100%;" src',
          );
        }
      }
    },

    getIsAnswered(questions) {
      if (questions.profileEnabled) {
        if (questions.conditionalQuestion) {
          if (questions.review) {
            return true;
          }

          if (questions.type === 'MULTIPLE') {
            if (
              questions.multipleValues &&
              questions.multipleValues.length > 0
            ) {
              return true;
            }
            return false;
          }

          return false;
        }
      }

      return null;
    },

    getConditionalQuestion(questions) {
      if (questions.profileEnabled) {
        return questions.selectedProfile;
      }

      return null;
    },

    getDeviceInfo() {
      let deviceInfo = null;
      try {
        deviceInfo = bowser.parse(window.navigator.userAgent);
      } catch (error) {
        window.console.log(error);
      }
      return deviceInfo;
    },

    async loadDeviceUUID() {
      // const useFingerprintJS = false;
      // if(useFingerprintJS){
      const fpPromise = FingerprintJS.load();
      const fp = await fpPromise;
      const result = await fp.get();
      this.visitorId = result.visitorId;
      // } else {
      //   // Obter informações do navegador
      //   const browserInfo = {
      //     userAgent: navigator.userAgent,
      //     cooke: document.cookie
      //   };

      //   // Obter informações de resolução
      //   const resolution = {
      //     screenWidth: screen.width,
      //     screenHeight: screen.height,
      //     devicePixelRatio: window.devicePixelRatio
      //   };

      //   // Combinar informações em um objeto
      //   const hashInfo = {
      //     browser: browserInfo,
      //     resolution,
      //   };

      //   // Codificar o objeto em uma string JSON e depois em base64
      //   const hash = btoa(JSON.stringify(hashInfo));

      //   this.visitorId = hash;
      // }
    },

    replaceTagsOnText(researchInfo, value) {
      const arrayOfTags = [];
      arrayOfTags.push(
        {
          key: 'nota',
          value: value ? value : this.$route.params.grade,
        },
        {
          key: 'pnota',
          value: value ? value : this.$route.params.grade,
        },
      );
      let promoters = researchInfo.reply.promoters;
      let neutral = researchInfo.reply.neutral;
      let detractors = researchInfo.reply.detractors;
      arrayOfTags.forEach((tag) => {
        const regexTags = new RegExp(`<${tag.key}>`, 'gi');
        if (tag.value === ' ') {
          tag.value = 0;
        }
        if (promoters) {
          promoters = promoters.replace(
            regexTags,
            tag.value ? tag.value : this.$route.params.grade,
          );
          this.promotersQuestion = promoters;
        }
        if (neutral) {
          neutral = neutral.replace(
            regexTags,
            tag.value ? tag.value : this.$route.params.grade,
          );
          this.neutralQuestion = neutral;
        }
        if (detractors) {
          detractors = detractors.replace(
            regexTags,
            tag.value ? tag.value : this.$route.params.grade,
          );
          this.detractorsQuestion = detractors;
        }
      });
    },
    indicatorValuedQuestion(item) {
      if (item.indicatorValueEnabled) {
        for (let i = 0; i < this.researchInfo.indicators.length; i += 1) {
          if (item.indicatorCriterion === 'equal') {
            if (
              item.selectedIndicator && this.researchInfo.indicators[i].column &&
              this.researchInfo.indicators[i].column.toLowerCase() ===
                item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.researchInfo.indicators[i].value && item.indicatorValue &&
                this.researchInfo.indicators[i].value.toLowerCase() ===
                  item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'different') {
            if (
              item.selectedIndicator && this.researchInfo.indicators[i].column && this.researchInfo.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.researchInfo.indicators[i].value && item.indicatorValue &&
                this.researchInfo.indicators[i].value.toLowerCase() !==
                  item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'contains') {
            if (
              item.selectedIndicator && this.researchInfo.indicators[i].column &&
              this.researchInfo.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.researchInfo.indicators[i].value && item.indicatorValue &&
                this.researchInfo.indicators[i].value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '') // remove accents
                  .toLowerCase()
                  .includes(
                    item.indicatorValue
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase(),
                  )
              ) {
                return true;
              }
              break;
            }
          }
        }
        return false;
      }
      return true;
    },

    returnLang(dataAction) {
      if (!this.$route.query.lang) {
        if (dataAction.enableTranslation) {
          if (dataAction.action.email.template.enableMyHTMLPt) {
            this.langView = 'br';
          } else if (dataAction.action.email.template.enableMyHTMLEn) {
            this.langView = 'us';
          } else {
            this.langView = 'es';
          }
        } else {
          this.langView = 'br';
        }
      } else {
        this.langView = this.$route.query.lang;
      }

      return this.langView;
    },
  },
  computed: {
    ...mapState('actions', ['testNpsReview']),
  },
  watch: {
    testNpsReview: function watchGrade(value) {
      this.replaceTagsOnText(this.researchInfo, value);
    },
  },
  async created() {
    this.apiRoot = process.env.API_ROOT;
    this.apiServerless = process.env.API_SERVERLESS;
    try {
      const response = await this.getInfo(this.$route.params.token);
      this.researchInfo = response;

      const companyData = await api.get(
        `/surveys/companies/${this.researchInfo.action.companyId}`,
      );
      this.company = companyData.data;

      if (this.researchInfo.enabledAudioResponse) {
        this.enabledAudioResponse = true;
      }

      if (this.researchInfo.action.allAnswersAnonymous) {
        this.anonymousResponse = true;
      }
      this.$store.state.actions.action = this.researchInfo.action;
      this.replaceTagsOnText(this.researchInfo);
      this.setTestNpsReview(parseInt(this.$route.params.grade, 10));
      this.researchInfo.additionalQuestions.forEach((el) => {
        if (el.type === 'MULTIPLE') {
          el.addQuestionAnswerMultiple = {
            multipleValues: [],
            comment: null,
          };

          if (el.isRandomizeQuestionOrder) {
            this.shuffleArray(el.choices);
            const choices = el.choices;
            if (choices.length > 0) {
              for (let j = 0; j < choices.length; j += 1) {
                if (choices[j].subChoices && choices[j].subChoices.length > 0) {
                  this.shuffleArray(choices[j].subChoices);
                }
              }
            }
          }
        } else if (el.type === 'INPUT') {
          el.answerText = null;
        } else if (el.type === 'CONTACT') {
          if (el.displayType === 'afterSendAnswer') {
            this.typeModalContact = true;
          }
        } else {
          el.addQuestionAnswer = {
            review: null,
            comment: null,
          };
        }
      });
      if (this.researchInfo.metric.includes('0-10')) {
        this.promotersGrades = [10, 9];
        this.passivesGrades = [8, 7];
        this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
      }

      if (this.researchInfo.metric === 'like-dislike') {
        this.promotersGrades = [1];
        this.detractorsGrades = [0];
      }

      const logoUrl = process.env.INDECX_FILES_BUCKET;
      this.logo = `${logoUrl}/${response.logo}`;

      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.error = error.response.data.message;
    }

    // this.langView = this.$route.query.lang || 'br';

    this.langView = this.returnLang(this.researchInfo);

    if (this.langView === 'br') {
      this.text = this.researchInfo.text;
      this.question = this.researchInfo.action
        ? this.researchInfo.action.question
        : null;
      this.questionHTML = this.researchInfo.action
        ? this.researchInfo.action.questionHTML
        : null;
      this.myHTML = this.researchInfo.action
        ? this.researchInfo.action.email.template.myHTML
        : null;
    }
    if (this.langView === 'us') {
      this.text = this.researchInfo.textEn;
      this.question = this.researchInfo.action.questionEn;
      this.questionHTML = this.researchInfo.action.questionHTMLEn;
      this.myHTML = this.researchInfo.action.email.template.myHTMLEn;
    }
    if (this.langView === 'es') {
      this.text = this.researchInfo.textEs;
      this.question = this.researchInfo.action.questionEs;
      this.questionHTML = this.researchInfo.action.questionHTMLEs;
      this.myHTML = this.researchInfo.action.email.template.myHTMLEs;
    }

    if (this.researchInfo.action && this.researchInfo.action.typeform) {
      this.isTypeForm = true;
      this.typeformHtml = this.researchInfo.action.typeform;

      const { email, phone, name, _id } = this.researchInfo;
      const indicators = this.researchInfo.indicators
        .map((a) => {
          return `${a.column}=${a.value}`;
        })
        .join(',');

      const hiddenFields = [
        ...indicators,
        `name=${name}`,
        `email=${email}`,
        `phone=${phone}`,
        `inviteId=${_id}`,
      ];

      const element = document.getElementById('_form');

      setTimeout(() => {
        const firstChild = element.firstChild;
        firstChild.setAttribute('data-tf-hidden', hiddenFields);

        const plugin = document.createElement('script');
        plugin.setAttribute('src', '//embed.typeform.com/next/embed.js');
        plugin.async = true;
        document.head.appendChild(plugin);
      }, 400);
    }

    if(this.researchInfo && this.researchInfo._id){
      await api.post(`/status-event/${this.researchInfo._id}`);
    }
  },
  mounted() {
    // adicionado para contornar o bug do touch no evento :hover em dispositivos mobile
    document.addEventListener('touchstart', function addtouchclass(e){ // first time user touches the screen
        document.documentElement.classList.add('can-touch') // add "can-touch" class to document root using classList API
        document.removeEventListener('touchstart', addtouchclass, false) // de-register touchstart event
    }, false)
    this.loadDeviceUUID();
    this.handleClosingMessage();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loadingSubmit {
  position: fixed;
  z-index: 99999;
  height: 50%;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 1;
}

.sk-wave {
  width: 50px;
  height: 180px;
  text-align: center;
  font-size: 10px;
}

.dark-mode {
  filter: brightness(50%);
}

.closing-message-area {
  display: flex;
  flex-direction: column;
  i {
    font-size: 92px;
    color: #009bdb;
  }
  h4 {
    color: #009bdb;
  }
}
.error-area {
  display: flex;
  flex-direction: column;
  i {
    font-size: 92px;
    color: #009bdb;
  }
  h4 {
    color: #009bdb;
  }
}
.wrapp {
  background-color: $gray-lighter;
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  overflow: auto;
}
.container {
  min-height: 100vh;
  background-color: #fff;
}
.question {
  font-size: 1.1rem;
}
.required {
  color: red;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/research-page/index.vue